import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { InvoicesReportPage } from "src/components/views/erp/sales/invoicing/reports/InvoicesReportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/invoicing/reports/invoices")({
	staticData: { title: i18n.t("invoices"), legacyViewKey: "invoicesReportPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <InvoicesReportPage />;
}
